<div class="item-container">
    <div class="item-header">
        <h5 class="text-center">{{"View Contract" | translate}}</h5>
        <div class="edit-icons" mat-dialog-close="">
            <i class="material-icons">close</i>
        </div>
    </div>
    <div class="item-content d-flex flex-column justify-content-center pt-3 pt-lg-4">

        <pdf-viewer [src]="serverFileName"
        [render-text]="true"
        [original-size]="false"
        style="width: 100%; height: 100%" ></pdf-viewer>
    </div>
</div>